export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Nord',
        name_es: 'Norte',
        name_en: 'North'
    }, {
        id: 3,
        name_ca: 'Nord-Est',
        name_es: 'Noreste',
        name_en: 'North-East'
    }, {
        id: 4,
        name_ca: 'Est',
        name_es: 'Este',
        name_en: 'East'
    }, {
        id: 5,
        name_ca: 'Sud-Est',
        name_es: 'Sureste',
        name_en: 'South-East'
    }, {
        id: 6,
        name_ca: 'Sud',
        name_es: 'Sur',
        name_en: 'South'
    }, {
        id: 7,
        name_ca: 'Sud-Oest',
        name_es: 'Suroeste',
        name_en: 'South-West'
    }, {
        id: 8,
        name_ca: 'Oest',
        name_es: 'Oeste',
        name_en: 'West'
    }, {
        id: 9,
        name_ca: 'Nord-Oest',
        name_es: 'Noroeste',
        name_en: 'Nort-West'
    }
]





// WEBPACK FOOTER //
// ./src/options/orientations.js